import { MULTI_ADS_AREA_PART_TYPE } from './constants';
import { IOffer } from '../../../../types/offer';

export function getMultiAdsAreaPartType(offer: IOffer): string {
  const category = offer.category;

  if (!category) {
    return '';
  }

  for (const stem of Object.keys(MULTI_ADS_AREA_PART_TYPE)) {
    if (category === `${stem}Rent` || category === `${stem}Sale`) {
      return MULTI_ADS_AREA_PART_TYPE[stem];
    }
  }

  return '';
}
